export const hideOrShowPagination = (contentType, nbHits = null) => {
    if (contentType === 'most_relevant_results' || !contentType) hidePagination();
    else {
        if (nbHits !== null && nbHits === 0) hidePagination();
        else showPagination();
    }
}

const hidePagination = () => {
    const pagination = document.getElementById("pagination");
    if (pagination) pagination.style.display = "none";
}

const showPagination = () => {
    const pagination = document.getElementById("pagination");
    if (pagination) pagination.style.display = "block";

}
